import(/* webpackMode: "eager" */ "C:\\Repos\\Orto_App_New\\FrontEnd\\orto-web\\src\\app\\[lng]\\error.tsx");
